import { render, staticRenderFns } from "./DocumentRegister.vue?vue&type=template&id=21c81de0&"
import script from "./DocumentRegister.vue?vue&type=script&lang=ts&"
export * from "./DocumentRegister.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports